export default [

    {
        path: '',
        name: 'ajuda',
        redirect: { name: 'ajuda-fale-conosco' },
    },

    {
        path: 'fale-conosco',
        name: 'ajuda-fale-conosco',
        component: () => import('@/aplicacao/modulos/ajuda/FaleConosco'),
        meta: { autenticacao: true, permissao: 'ROLE_AJUDA' },
    },

    {
        path: 'chamados/historico',
        name: 'ajuda-chamados-historico',
        component: () => import('@/aplicacao/modulos/ajuda/chamados/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_AJUDA_CHAMADOS' },
    },

    {
        path: 'chamados/em-aberto',
        name: 'ajuda-chamados-em-aberto',
        component: () => import('@/aplicacao/modulos/ajuda/chamados/EmAberto'),
        meta: { autenticacao: true, permissao: 'ROLE_AJUDA_CHAMADOS' },
    },

    {
        path: 'chamados/pendentes',
        name: 'ajuda-chamados-pendentes',
        component: () => import('@/aplicacao/modulos/ajuda/chamados/Pendentes'),
        meta: { autenticacao: true, permissao: 'ROLE_AJUDA_CHAMADOS' },
    },

    {
        path: 'chamados/novo',
        name: 'ajuda-chamados-novo',
        component: () => import('@/aplicacao/modulos/ajuda/chamados/Novo'),
        meta: { autenticacao: true, permissao: 'ROLE_AJUDA_CHAMADOS_ABRIR' },
    },

    {
        path: 'chamados/:id',
        name: 'ajuda-chamados-fluxo',
        component: () => import('@/aplicacao/modulos/ajuda/chamados/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_AJUDA_CHAMADOS' },
    },

]
